"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPartnerDatasetApiClient = createPartnerDatasetApiClient;
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function createPartnerDatasetApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    const pathPartnerDataset = (partnerDatasetId) => {
        if (partnerDatasetId) {
            return `/v1/dataset/partners/${partnerDatasetId}`;
        }
        else {
            return `/v1/dataset/partners`;
        }
    };
    async function getPartnerDataset(params) {
        try {
            const response = await client.get(pathPartnerDataset(params.partnerDatasetId));
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function createPartnerDataset(data) {
        try {
            const response = await client.post(pathPartnerDataset(), data);
            const location = response.headers.location || '';
            return location.replace('/v1/dataset/partners/', '');
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function deletePartnerDataset(params) {
        try {
            await client.delete(pathPartnerDataset(params.partnerDatasetId));
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function deleteUser(request, options) {
        try {
            return await client.post('v1/dataset/delete-user-request', request, { params: options });
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    return {
        getPartnerDataset,
        deletePartnerDataset,
        createPartnerDataset,
        deleteUser
    };
}
